@switch (mode()) {
	@case ("RENAME") {
		@if (entry.icon) {
			<i class="ico" [ngClass]="entry.icon"></i>
		}
		<ng-content />
	}
	@case ("ADD") {
		@if (entry.icon) {
			<i class="ico" [ngClass]="entry.icon"></i>
		}
		<ng-content />
	}
	@default {
		@if (entry.icon) {
			<i class="ico" [ngClass]="entry.icon"></i>
		}
		<div class="text">
			@if (entry.label) {
				<h3 [ngClass]="entry.labelClasses">{{ entry.label }}</h3>
			}
			@if (entry.labelTranslate) {
				<h3 [translate]="entry.labelTranslate"></h3>
			}
		</div>
		<ng-container />
	}
}
